export enum AvailableLanguages {
    EN = 'en',
    FR = 'fr'
}

export const defaultLanguage = AvailableLanguages.EN;

export const APP_LANGUAGE = 'APP_LANGUAGE';